module.exports = __webpack_public_path__ + "img/org-moh2.1e3a0b7e.jpg";